"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var assetAnalysis_1 = require("../../model/assetAnalysis");
var service_1 = require("../../../library/base/service");
var Init = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Init, _super);
    function Init() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '资产分析接口';
        _this.code = '100002';
        _this.desc = '资产分析接口';
        _this.requestParams = new assetAnalysis_1.InitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Init;
}(service_1.BaseService));
exports.Init = Init;
//# sourceMappingURL=init.js.map